import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { RequestService } from '../core/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OffVpnGuard {
  constructor(
    private requestService: RequestService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!(await this.requestService.pingBackend())) {
      return this.router.parseUrl('/off-vpn');
    }

    return true;
  }
}
